import * as React from 'react';
import Alert, { AlertCategoryEnum } from './Alert';
import { Link, useHistory } from 'react-router-dom';
import { SaveCurrentPath } from '../../Core';

export const MultiStudyBrickwall = () => {
    const history = useHistory();

    return (
        <Alert category={AlertCategoryEnum.Danger} show={true}>
            Please select a specific study to view this area. <a onClick={() => { SaveCurrentPath(history); history.push("/account/study") }}>Switch Study</a>
        </Alert>
    );
}
